module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-usd-circle fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.valueBased ? 'Aconto faktureret' : 'Omsætning'))]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.invoices_total ? _vm.project.invoices_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.timelog_hours ? _vm.project.timelog_hours : 0)) + " timer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.timelog_total ? _vm.project.timelog_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.materials_count ? _vm.project.materials_count : 0)) + " materialer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.material_total ? _vm.project.material_total : 0)))])]), _vm._v(" "), (_vm.valueBased && _vm.project.type) ? _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Gns. DG \"" + _vm._s(_vm.project.type.name) + "\""), _c('br'), _c('span', {
    staticStyle: {
      "opacity": "0.5",
      "font-size": "12px"
    }
  }, [_vm._v("DG udregnet for de seneste 6 mdr.")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("coveragePercent")(_vm.project.type.avg_coverage_percent)) + " %")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), (!_vm.valueBased) ? _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.coverage > 0, 'bad': _vm.project.coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.coverage ? _vm.project.coverage : 0)))])]) : _vm._e(), _vm._v(" "), (_vm.valueBased && !_vm.valueBasedWithCP) ? _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Værdi")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.value > 0, 'bad': _vm.project.value < 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("realCurrency")(_vm.project.value)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.valueBased && _vm.valueBasedWithCP) ? _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Værdi")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.value_with_avg_cp > 0, 'bad': _vm.project.value_with_avg_cp < 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("realCurrency")(_vm.project.value_with_avg_cp)) + "\n                    ")])]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22a330da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ProjectTooltip.vue
// module id = 821
// module chunks = 0